import React from "react";

import TxnNetsFailStatusLayout from "./txn_nets_fail_status_layout";

const TxnNetsFailStatusPage = () => {
  return (
    <>
      <TxnNetsFailStatusLayout />
    </>
  );
};

export default TxnNetsFailStatusPage;